<template>

<div class="inquiry-block bg-color--light-grey">

	<div class="container">
		<div class="col-12 col-lg-6 offset-lg-1">

			<div class="c-inquiry">

				<div class="c-inquiry__head">

					<p class="c-inquiry__title">
						{{msg.what_interest}}
					</p>

					<div class="c-custom-select c-inquiry__category-select">
						<input readonly="readonly" type="text" name="" @click="openMasterDropdown = !openMasterDropdown" class="c-custom-select__trigger c-custom-select__trigger--large" :value="categoryName" placeholder="Contact us">
						<ul class="c-custom-select__list" v-show="openMasterDropdown">
							<li v-for="subject in inquirySubjects" @click="currentStep = subject.id; openMasterDropdown = !openMasterDropdown; firstView = false" :key="subject.id" :value="subject.name" class="c-custom-select__list-item"><span class="c-custom-select__list-subitem">{{subject.name}}</span></li>
						</ul>
					</div>

				</div>





				<form action="" method="POST" id="inquiry-form" enctype="multipart/form-data" class="inquiry-form c-inquiry__form">
					<!-- Reservations -->
					<ReservationsForm :required_fields='config.required_fields["reservations"]' v-if="currentStep == 0"></ReservationsForm>
					<!-- Mice sales -->
					<MiceSalesForm :required_fields='config.required_fields["mice"]' v-if="currentStep == 1"></MiceSalesForm>
					<!-- Mice RFP -->
					<MiceRfpForm :required_fields='config.required_fields["micerfp"]' v-if="currentStep == 2"></MiceRfpForm>
					<!-- Concierge -->
					<ConciergeForm :required_fields='config.required_fields["concierge"]' v-if="currentStep == 3"></ConciergeForm>
					<!-- Childcare -->
					<ChildcareForm :required_fields='config.required_fields["childcare"]' v-if="currentStep == 4"></ChildcareForm>
					<!-- Sports Academy -->
					<SportsAcademyForm :required_fields='config.required_fields["sport"]' v-if="currentStep == 5"></SportsAcademyForm>
					<!-- Contact us -->
					<ContactUsForm :required_fields='config.required_fields["contact"]' v-if="currentStep == 6"></ContactUsForm>
					<!-- Newsletter  -->
					<!-- <NewsletterForm v-if="currentStep == 6"></NewsletterForm> -->
					<!-- MediaInquiry -->
					<MediaEnquiryForm :required_fields='config.required_fields["media"]' v-if="currentStep == 7"></MediaEnquiryForm>
					<!-- Job Application Form -->
					<JobApplicationForm :required_fields='config.required_fields["jobs"]' :maxFileSize='config.max_file_size' v-if="currentStep == 8"></JobApplicationForm>
					<!-- SpaCenter -->
					<SpaCenterEnquiryForm :required_fields='config.required_fields["spacenter"]' v-if="currentStep == 9"></SpaCenterEnquiryForm>


					<input type="hidden" name="inquiry_interest" :value="formName">
					<div id="recapcha" class="g-recaptcha"></div>
					<button type="submit" @click.prevent="submit()" name="" class="inquiry-form__input-submit btn btn-secondary">{{msg.contact_send}}</button>

					<div v-if="formSuccess" class="c-inquiry__notice">
						<p class="c-inquiry__notice-title">
							<strong>{{msg.form_success}}</strong>
						</p>
					</div>
					<div v-if="errorMsg" class="c-inquiry__notice c-inquiry__notice--red">
						<p class="c-inquiry__notice-title c-inquiry__notice-title--red">
							{{msg.form_error}}
						</p>
					</div>
					
				</form>
			</div>

		</div>
	</div>

</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapState } from "vuex";

export default {
	props: {
		config: Object
	},
	components: {
		Multiselect
	},
	data: () => ({
		inquirySubjects: [],
		openDropdown: false,
		openMasterDropdown: false,
		validationError: false,
		currentStep: 0,
		currentStepName: "",
		firstView: true,
		onFocus: false,
		errorMsg: false,
		formSuccess: false,
		default_config: {
			"inquiry_interest" : false,
			"inquiry_accommodation" : false,
			"activity" : false,
			"service" : false,
			"coverage_type" : false,
			"media_name" : false,
			"media_type" : false,
			"media_viewership" : false,
			"project_description" : false,
			"company_name" : false,
			"event_dates" : false,
			"event_name" : false,
			"first_name" : false,
			"last_name" : false,
			"email" : false,
			"phone" : false,
			"address" : false,
			"country" : false,
			"freelancer_description" : false,
			"date_from" : false,
			"date_to" : false,
			"guest_number" : false,
			"room_number" : false,
			"fb_requirements" : false,
			"meeting_requirements" : false,
			"message" : false,
			"gdpr_accept" : false,
			"newsletter_accept" : false,
		}
	}),
	computed: {
		categoryName() {
			if (this.firstView == true) {
				return this.inquirySubjects[0].name;
			}
			else {
				return this.inquirySubjects[this.currentStep].name
			}
		},
		formName() {
			if (this.firstView == true) {
				return this.inquirySubjects[0].hash;
			}
			else {
				return this.inquirySubjects[this.currentStep].hash
			}
		},
		...mapState({
			msg: state => state.msg
		})
		
	},
	created() {
		

		this.inquirySubjects = [
			{
				id: 0,
				name: this.msg.int_reservations,
				hash: 'reservations' 
			},
			{
				id: 1,
				name:this.msg.int_mice,
				hash: 'mice' 
			},
			{
				id: 2,
				name: this.msg.int_micerfp,
				hash: 'micerfp' 
			},
			{
				id: 3,
				name: this.msg.int_concierge,
				hash: 'concierge' 
			},
			{
				id: 4,
				name: this.msg.int_childcare,
				hash: 'childcare' 
			},
			{
				id: 5,
				name: this.msg.int_sports,
				hash: 'sport' 
			},
			{
				id: 6,
				name: this.msg.int_contact,
				hash: 'contact' 
			},
			{
				id: 7,
				name: this.msg.int_media,
				hash: 'media' 
			},
			{
				id: 8,
				name: this.msg.int_job_application,
				hash: 'jobs' 
			},
			{
				id: 9,
				name: this.msg.int_spa_center,
				hash: 'spacenter' 
			},
		];
		let predefinedCat = window.location.hash;
		if (predefinedCat) {
			this.setCategory(predefinedCat);
		}
		for(var idx in this.config.required_fields)
		{
			
			this.config.required_fields[idx] = {...this.default_config, ...this.config.required_fields[idx]};
			// console.log(conf);
		}
		this.$store.commit("changeConfig", this.config);

	},
	mounted() {
		//cringe kod za hide dropdowna, TODO:fix it tomislave
		let self = this;
		window.addEventListener('click', function(e){
			// close dropdown when clicked outside
			if (!e.target.classList.contains('c-custom-select__trigger')) {
				self.openMasterDropdown = false;
			} 
		});
	},
	methods: {
		setCategory(predefinedCat) {
			let category = predefinedCat.replace('#', '');
			
			let categories = this.inquirySubjects;
			
			let setStep = categories.filter(function(item) {
				let hash = item.hash.toLowerCase();
				return hash.match(category);
			});

			if (setStep.length) {
				this.currentStep = setStep[0].id;
			} else {
				this.currentStep = 0;
			}
		
			this.firstView = false;
		},
		formToObject(serializedForm) {
			let pairs, i, keyValuePair, key, value, map = {};

			// remove leading question mark if its there
			if (serializedForm.slice(0, 1) === '?') {
				serializedForm = serializedForm.slice(1);
			}

			if (serializedForm !== '') {
				pairs = serializedForm.split('&');

				for (i = 0; i < pairs.length; i += 1) {
					keyValuePair = pairs[i].split('=');

					key = decodeURIComponent(keyValuePair[0]);
					value = (keyValuePair.length > 1) ? decodeURIComponent(keyValuePair[1]) : undefined;

					map[key] = value;
				}
			}

			return map;
		},
		submit() {
			//remove err classes if any
			$('.inquiry-form__input-text').removeClass('inquiry-form__input-text--error');
			this.formSuccess = false;
			this.errorMsg = false;

			setTimeout(callback.bind(this), 1500);//submitaj form ako google timeouta

			let submitted = false;
			if (typeof gtag !== 'undefined')
			{
				gtag('event', 'submit', {
					'event_category': 'Inquiry submission',
					'event_label': this.inquirySubjects[this.currentStep].name,
					'value': this.currentStep,
					'event_callback':callback.bind(this)  //submitaj nakon googlea
				});
			}

			// var self = this;
			function callback()
			{
				if (!submitted)
				{			
					if(this.currentStep == 8)
					{
						let formdata = new FormData( $('#inquiry-form')[0] );
						$('input[type=checkbox]').each(function(idx, el)
						{
							let name = $(this).attr('name');
							if ( formdata.getAll(name).length > 1 )
							{
								formdata.set( name, "true" );
							}
						})
						
						$.ajax({
							url: '/' + langCode + '/xinquiry',
							type: 'POST',
							dataType: "JSON",
							data: formdata,
							processData: false,
							contentType: false,
							success: function (data, status)
							{
								if (data.success == true)
								{
									this.formSuccess = true;
									//reset form 
									$('input').not('[type=checkbox]').val('');
									$('textarea').val('');
									$('span#custom-text').html('');
									$('input[type=checkbox]').prop('checked', false);
								}
								else
								{
									this.errorMsg = true;
									$('input[type=checkbox]').prop('checked', false);
									Object.keys(data.form_error).forEach(item => {
										if (data.form_error[item]) {
											$('.c-inquiry').find('input[name='+ item + ']').addClass('inquiry-form__input-text--error');
	
											//check if the datepicker has dates selected, if not add the error class
											if (item === 'date_to') {
												$('.el-date-editor').addClass('inquiry-form__input-text--error');
											}
											if (item === 'file')
											{
												$('span#custom-text').addClass('inquiry-form__input-text--error');												
											}
										}
									});
								}
							}.bind(this),
							error: function (xhr, desc, err)
							{
								console.log("error", err);
							}.bind(this)
						});  
					}
					else
					{
						//serialize form
						let formObject = this.formToObject( $('#inquiry-form').serialize() );
						// console.log("TCL: submit -> formObject", formObject)
						//create FormData
						let formData = new FormData();
						Object.keys(formObject).forEach(key => {
							formData.append(key, formObject[key]);
						});

						submitted = true;
						axios.post(
							'/' + langCode + '/xinquiry', 
							formData, 
							{
								processData: false,
								contentType: false,
							}
						)
						.then(function (response) {
							// console.log(response);
							let responseData = response.data;
			
							if (responseData.success) {
								this.formSuccess = true;
								//reset form 
								$('input').not('[type=checkbox]').val('');
								$('span#custom-text').html('');
								$('textarea').val('');
								$('input[type=checkbox]').prop('checked', false);
			
			
							} else {
								this.errorMsg = true;
								
								Object.keys(responseData.form_error).forEach(item => {
									if (responseData.form_error[item]) {
										$('.c-inquiry').find('input[name='+ item + ']').addClass('inquiry-form__input-text--error');

										//check if the datepicker has dates selected, if not add the error class
										if (item === 'date_to') {
											$('.el-date-editor').addClass('inquiry-form__input-text--error');
										}
									}
								});
			
							}
			
						}.bind(this))
						.catch(function (error) {
							console.log(error);
						});

					}
				}
			}
		}
	}
}
</script>

 <style lang="scss">
.multiselect__content {
    background-color: #fff;
    margin: 0;
    min-width: 172px;
    overflow-y: auto;
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    top: calc(100% + 20px);
    z-index: 10;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    padding-left: 0;
    list-style-type: none;
    -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}
.multiselect__element{
    background-color: #fff;
    margin: 0;
    min-width: 172px;
    overflow-y: auto;
    // position: absolute;
    // left: 0;
    // right: 0;
    // width: 100%;
    top: calc(100% + 20px);
    z-index: 10;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    padding-left: 0;
    list-style-type: none;
    // -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    // box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.multiselect__option {
    font-size: 14px;
    font-size: 1.4rem;
    line-height: 1.28571em;
    font-family: "Mark Offc Pro", sans-serif;
    font-weight: 500;
    color: #212529;
    padding: 14px 16px;
    display: block;
    cursor: pointer;
    -webkit-transition: color 250ms ease-in-out, background-color 250ms ease-in-out;
    transition: color 250ms ease-in-out, background-color 250ms ease-in-out;
}

.multiselect {
    padding: 16px 22px;
    font-family: "Mark Offc Pro", sans-serif;
    font-weight: 500;
    color: #171a23;
    background: #fff url(/src/img/svg/drop-down-arrow-black.svg) no-repeat;
    background-size: 10px;
    background-position: right 18px top 50%;
    border: none;
    padding: 16px 22px;
    cursor: pointer;
    width: 100%;
    -webkit-box-shadow: inset 2px 0 0 0 #2a2c31;
    box-shadow: inset 2px 0 0 0 #2a2c31;
    font-size: 14px;
    font-size: 1.4rem;
    line-height: 1.28571em;
}
</style>

